import type { GraphQLTypes, InputType } from '@zeus/index'
import { $ } from '@zeus/index'
import { typedGql } from '@zeus/typedDocumentNode'
import { scalars } from '~/gql/utils/scalars'

const complaintFields = {
  id: true,
  createdAt: true,
  category: true,
  status: true,
  origin: true,
  subject: true,
  message: true,
  response: true,
  respondedAt: true,
  resolvedAt: true,
  authorName: true,
  authorEmail: true,
} as const

/** Le registre des demandes et réclamations de l'organisme (#325), aux admins. */
export const GQL_COMPLAINTS = typedGql('query', { scalars })({
  complaints: complaintFields,
})

export const GQL_CREATE_COMPLAINT = typedGql('mutation', { scalars })({
  createComplaint: [{ input: $('input', 'CreateComplaintInput!') }, complaintFields],
})

export const GQL_UPDATE_COMPLAINT = typedGql('mutation', { scalars })({
  updateComplaint: [{ input: $('input', 'UpdateComplaintInput!') }, complaintFields],
})

export type Complaint = InputType<GraphQLTypes['ComplaintModel'], typeof complaintFields, typeof scalars>
